module.exports = {
          srcSet: __webpack_public_path__ + "images/1928-05244f422e116106b213483a200c6952-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1928-8d81a699c263536a9bec287b1841bdc8-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1928-05244f422e116106b213483a200c6952-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1928-8d81a699c263536a9bec287b1841bdc8-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1928-05244f422e116106b213483a200c6952-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1928-05244f422e116106b213483a200c6952-320.jpg"},
          
          width: 320,
          height: 251
        }